<template>
  <CostumerAdofa />
</template>

<script>
import CostumerAdofa from "@/components/CostumerAdofa";
export default {
  name: "OurCostumer",

  components: {
    CostumerAdofa,
  },
};
</script>

<style></style>
